import FutureFlexHomePage from 'apps/futureflex/components/homepage';
import {
  InvestmentCompanyCreatePage,
  InvestmentCompanyDetailPage,
  InvestmentCompanyEditPage,
  InvestmentCompanyListPage,
} from 'apps/futureflex/components/Companies/pages';
import InvestmentCompanyPortfolio from 'apps/futureflex/components/Companies/portfolio';
import InvestmentCompanyRedistributionFund from 'apps/futureflex/components/Companies/redistributionFund';
import {
  InvestmentProgramOrderBundlePage,
  InvestmentProgramOrderCancelPage,
  InvestmentProgramOrderContinuePage,
  InvestmentProgramOrderDetailPage,
  InvestmentProgramOrderEditPage,
  InvestmentProgramOrderGeneratePage,
  InvestmentProgramOrderListPage,
  InvestmentProgramOrderRebundlePage,
} from 'apps/futureflex/components/EmployeeProgramOrders/pages';
import {
  ProgramDetailCreatePage,
  ProgramDetailDetailPage,
  ProgramDetailEditPage,
  ProgramDetailListPage,
  ProgramDetailPortfolioPage,
} from 'apps/futureflex/components/EmployeePrograms/pages';
import {
  InvestmentEmployeeCreatePage,
  InvestmentEmployeeDetailPage,
  InvestmentEmployeeEditPage,
  InvestmentEmployeeListPage,
} from 'apps/futureflex/components/Employees/pages';
import {
  InvestmentPlanCreatePage,
  InvestmentPlanListPage,
} from 'apps/futureflex/components/InvestmentPlan/config';
import {
  StaffCreatePage,
  StaffDetailPage,
  StaffEditPage,
  StaffListPage,
} from 'apps/futureflex/components/Staffs/pages';
import { Navigate, useLocation } from 'react-router-dom';

// Backward-compat redirect: /investment/<futureflex-resource>/* → /futureflex/*
const LegacyInvestmentRedirect = () => {
  const { pathname, search } = useLocation();
  return (
    <Navigate
      to={`${pathname.replace(/^\/investment\//, '/futureflex/')}${search}`}
      replace
    />
  );
};

const LEGACY_RESOURCES = [
  'companies',
  'employees',
  'employee-programs',
  'program-orders',
  'staffs',
];

const futureflexRoutes = [
  { path: '/futureflex/home', element: <FutureFlexHomePage /> },
  { path: '/futureflex/companies', element: <InvestmentCompanyListPage /> },
  {
    path: '/futureflex/companies/create',
    element: <InvestmentCompanyCreatePage />,
  },
  {
    path: '/futureflex/companies/:id',
    element: <InvestmentCompanyDetailPage />,
  },
  {
    path: '/futureflex/companies/:id/edit',
    element: <InvestmentCompanyEditPage />,
  },
  {
    path: '/futureflex/companies/:company_id/portfolio',
    element: <InvestmentCompanyPortfolio />,
  },
  {
    path: '/futureflex/companies/:company_id/redistribution-fund',
    element: <InvestmentCompanyRedistributionFund />,
  },
  { path: '/futureflex/employees', element: <InvestmentEmployeeListPage /> },
  {
    path: '/futureflex/employees/create',
    element: <InvestmentEmployeeCreatePage />,
  },
  {
    path: '/futureflex/employees/:id',
    element: <InvestmentEmployeeDetailPage />,
  },
  {
    path: '/futureflex/employees/:id/edit',
    element: <InvestmentEmployeeEditPage />,
  },
  {
    path: '/futureflex/employees/:id/info',
    element: <InvestmentEmployeeDetailPage />,
  },
  { path: '/futureflex/employee-programs', element: <ProgramDetailListPage /> },
  {
    path: '/futureflex/employee-programs/create',
    element: <ProgramDetailCreatePage />,
  },
  {
    path: '/futureflex/employee-programs/:id',
    element: <ProgramDetailDetailPage />,
  },
  {
    path: '/futureflex/employee-programs/:id/portfolio',
    element: <ProgramDetailPortfolioPage />,
  },
  {
    path: '/futureflex/employee-programs/:id/edit',
    element: <ProgramDetailEditPage />,
  },
  {
    path: '/futureflex/employee-programs/:id/investment-plans',
    element: <InvestmentPlanListPage />,
  },
  {
    path: '/futureflex/employee-programs/:id/investment-plans/create',
    element: <InvestmentPlanCreatePage />,
  },
  {
    path: '/futureflex/employee-programs/:id/edit',
    element: <ProgramDetailDetailPage />,
  },
  {
    path: '/futureflex/program-orders',
    element: <InvestmentProgramOrderListPage />,
  },
  {
    path: '/futureflex/program-orders/generate',
    element: <InvestmentProgramOrderGeneratePage />,
  },
  {
    path: '/futureflex/program-orders/bundle',
    element: <InvestmentProgramOrderBundlePage />,
  },
  {
    path: '/futureflex/program-orders/rebundle',
    element: <InvestmentProgramOrderRebundlePage />,
  },
  {
    path: '/futureflex/program-orders/rebundle-all',
    element: <InvestmentProgramOrderCancelPage />,
  },
  {
    path: '/futureflex/program-orders/continue',
    element: <InvestmentProgramOrderContinuePage />,
  },
  {
    path: '/futureflex/program-orders/:id/edit',
    element: <InvestmentProgramOrderEditPage />,
  },
  {
    path: '/futureflex/program-orders/:id',
    element: <InvestmentProgramOrderDetailPage />,
  },
  { path: '/futureflex/staffs', element: <StaffListPage /> },
  { path: '/futureflex/staffs/create', element: <StaffCreatePage /> },
  { path: '/futureflex/staffs/:id/edit', element: <StaffEditPage /> },
  { path: '/futureflex/staffs/:id', element: <StaffDetailPage /> },

  ...LEGACY_RESOURCES.map(resource => ({
    path: `/investment/${resource}/*`,
    element: <LegacyInvestmentRedirect />,
  })),
];

export default futureflexRoutes;
